// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import forkAndKnifeIcon from "@/assets/icons/aop/fork-and-knife.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ForkAndKnifeIconProps = Omit<IconProps, "name">;

export function ForkAndKnifeIcon(props: ForkAndKnifeIconProps): React.ReactNode {
  return <Icon name={forkAndKnifeIcon} {...props} />;
}
